module.exports = __webpack_public_path__ + "static/media/colheitadeira2.75e9864d.svg";